import React, { Fragment } from "react";
import { Grid } from "@material-ui/core";
import numeral from "numeral";
import _ from "lodash";
import moment from "moment";
import styled from "styled-components";
import { RadioInput, MoneyInput, IntegerInput } from "components/Global/FastFormikMaterial";
import { aggregateInterestMethods, DEFINED, FORMULAIC } from "constants/aggregateInterestMethods";

const StyledIntegerInput = styled(IntegerInput)`
  & {
    width:100%;
  }
`;
const StyledMoneyInput = styled(MoneyInput)`
  & {
    width:100%;
  }
`;
const RadioGrid = styled(Grid)`
  && {
    margin-top:20px;
  }
`;
class AggregateInterest extends React.Component {
  componentDidMount() {
    const { aggregateInterestMethodId, aggregateInterestMonthsOfInterest, aggregateInterestDefinedAmt } = this.props;
    this.setDescription(
      aggregateInterestMethodId,
      aggregateInterestMonthsOfInterest,
      aggregateInterestDefinedAmt
    );
  }

  componentDidUpdate(prevProps) {
    const { aggregateInterestMethodId, aggregateInterestMonthsOfInterest, aggregateInterestDefinedAmt } = this.props;
    const { aggregateInterestMethodId: prevAggregateInterestMethodId,
      aggregateInterestMonthsOfInterest: prevAggregateInterestMonthsOfInterest,
      aggregateInterestDefinedAmt: prevAggregateInterestDefinedAmt } = prevProps;
    if (aggregateInterestMethodId !== prevAggregateInterestMethodId ||
       aggregateInterestMonthsOfInterest !== prevAggregateInterestMonthsOfInterest ||
       aggregateInterestDefinedAmt !== prevAggregateInterestDefinedAmt) {
      this.setDescription(
        aggregateInterestMethodId,
        aggregateInterestMonthsOfInterest,
        aggregateInterestDefinedAmt
      );
    }
  }

  setDescription(aggregateInterestMethodId, aggregateInterestMonthsOfInterest, aggregateInterestDefinedAmt) {
    let description = "No description";
    if (aggregateInterestMethodId === DEFINED && aggregateInterestDefinedAmt) {
      description = `Minimum Interest of ${numeral(aggregateInterestDefinedAmt).format("$0,0")}`;
    } else if (aggregateInterestMethodId === FORMULAIC && aggregateInterestMonthsOfInterest) {
      description = `Penalty is calculated as [current rate] paid over ${aggregateInterestMonthsOfInterest} months`;
    }
    this.props.setDescription(description);
  }

  render() {
    const { index } = this.props;

    return (
      <>
        <RadioGrid item xs={8}>
          <RadioInput
            label="Aggregate Interest Method"
            options={aggregateInterestMethods}
            fieldName={`prepaymentSchedules[${index}].aggregateInterestMethodId`}
          />
        </RadioGrid>
        <Grid item xs={4} />
        <Grid item xs={4}>
          <StyledMoneyInput
            label="Prepayment Amount"
            fieldName={`prepaymentSchedules[${index}].aggregateInterestDefinedAmt`}
          />
        </Grid>
        <Grid item xs={1} />
        <Grid item xs={4}>
          <StyledIntegerInput
            label="Months"
            fieldName={`prepaymentSchedules[${index}].aggregateInterestMonthsOfInterest`}
          />
        </Grid>
      </>
    );
  }
}
export default AggregateInterest;
